import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux';
import IntlMessages from 'util/IntlMessages';

import Widget from "components/prefabricated/Widget";
import {fetchCustomers} from "../../../actions";
import CircularProgress from "@material-ui/core/CircularProgress";
import BBIconBuildings from "../../../assets/bbCustomIcons/BBIconBuildings";
import {bbDoesCustomerHaveAccessToSubscription} from "../../../util/bbHelpers";

const ActiveClientsTile = (props) => {

    const { title = null, subTitle = null, color = "electric-blue", colorTitle = "white", colorSubTitle = "white"} = props;



    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const dispatch = useDispatch();

    const customers = useSelector(({customer}) => customer.customers);
    const {authUser} = useSelector(({auth}) => auth);
    const {loadingCustomers, loadingCustomersError} = useSelector(({customer}) => customer);
    const numCustomers = customers ? Object.keys(customers).length : 0;

    const activeCustomers = customers && Object.values(customers)
        .filter((customer)=>
            bbDoesCustomerHaveAccessToSubscription(customer, 0)
        || bbDoesCustomerHaveAccessToSubscription(customer, 1)
        || bbDoesCustomerHaveAccessToSubscription(customer, 2));

    const numActiveCustomers = customers
        && activeCustomers
        && Array.isArray(activeCustomers)
        && activeCustomers.length;

    useEffect(() => {
        // console.group("ActiveClientsTile");
        // console.log("ActiveClientsTile here is the store", customers, " and here is num customers: ", numCustomers);
        if (customers == null && authUser) {
            // console.log("Customers is empty, fetching. numCustomers is ", numCustomers, "authUser", authUser);
            dispatch(fetchCustomers());
        }
        // console.groupEnd()
    }, [customers, dispatch, authUser]);

    /**************************/
    /*END Setup State and Dispatch*/
    /**************************/

    const displayValue = () => {
        // console.log("Determining display value.  here is customers: ", customers);
        if (title) {
            return title;
        } else if (loadingCustomers) {
            return "";
        } else if (!customers) {
            // console.log("Customers has been evaluated to undefined, returning blank.");
            return "";
        } else if (!numCustomers) {
            return "";
        } else {
            return <div className={"animated fadeIn animation-duration-5"}> {numActiveCustomers}</div>;
        }
    }

  return (
    <Widget styleName={`px-2 bg-${color}`}>
      <div className="d-flex flex-row justify-content-center mt-1 mb-4">
          <span
            className={`size-70 border-${colorTitle} text-${colorTitle} d-flex flex-row justify-content-center align-items-center rounded-circle`}>
            <BBIconBuildings style={{fontSize: 70}}/></span>
      </div>
      <div className="text-center">
        <h2 className={`jr-fs-xxxl jr-font-weight-bold text-${colorTitle} mb-2`}>
            {(!loadingCustomers && !loadingCustomersError) &&
                displayValue()
            }
        {
            (loadingCustomers) &&

                <CircularProgress size={"0.8em"} color={"inherit"} thickness={1.5}/>

        }
        {
            (loadingCustomersError) &&
            <div className="loader-view">
                !
            </div>
        }
        </h2>
        <span className={`text-${colorSubTitle}`}>{!subTitle ? <IntlMessages id="dashboard.clients"/> : subTitle}</span>
      </div>
    </Widget>
  );
};

export default ActiveClientsTile;
